<template>
  <div class="mb-5 mt-8">
    <div class="font-bold">{{ t("externalApproverAssignments.title") }}</div>
    <div class="text-medium-emphasis text-sm">
      {{ t("externalApproverAssignments.description") }}
    </div>
  </div>
  <v-table density="compact" class="mt-4">
    <thead>
      <tr>
        <th class="text-left assigned-column">{{ t("externalApproverAssignments.assigned") }}</th>
        <th class="text-left">{{ t("externalApproverAssignments.email") }}</th>
      </tr>
    </thead>
    <tbody>
      <template v-if="loading">
        <tr>
          <td colspan="2" class="p-0 border-none">
            <v-skeleton-loader type="table-tbody"></v-skeleton-loader>
          </td>
        </tr>
      </template>
      <template v-else>
        <tr v-for="externalApprover in externalApprovers" :key="externalApprover.uid">
          <td class="assigned-column">
            <v-checkbox
              v-model="selected"
              color="primary"
              :value="externalApprover.uid"
              :disabled="loading"
              hide-details
              density="compact"
            ></v-checkbox>
          </td>
          <td>{{ externalApprover.email }}</td>
        </tr>
        <tr v-if="!externalApprovers.length">
          <td colspan="2" class="text-center text-medium-emphasis">
            {{ t("externalApproverAssignments.noExternalApprovers") }}
          </td>
        </tr>
      </template>
    </tbody>
  </v-table>
</template>

<script setup lang="ts">
import { useCollection } from "@/composables/useFirestore";
import { useI18n } from "@/composables/useI18n";
import { db } from "@/firebase";
import { useUserStore } from "@/store/user";
import type { SupervisorOrgUser } from "@aircap/common/supervisorOrg";
import { supervisorOrgUsersFullPath } from "@aircap/common/supervisorOrg";
import { collection, query, where } from "firebase/firestore";
import { computed } from "vue";

const { t } = useI18n();
const user = useUserStore();

const selected = defineModel<string[]>({
  required: true,
});

defineProps<{
  loading: boolean;
}>();

const externalApproversQuery = computed(() =>
  user.supervisorOrgId
    ? query(
        collection<SupervisorOrgUser>(db, supervisorOrgUsersFullPath(user.supervisorOrgId)),
        where<SupervisorOrgUser>("role", "==", "externalApprover"),
      )
    : null,
);

const { data: externalApprovers } = useCollection<SupervisorOrgUser>(externalApproversQuery);
</script>

<style scoped>
.assigned-column {
  width: 100px;
  max-width: 100px;
}
</style>
